import { ItemLocationTimelineSkeleton } from '@/components/skeletons/ItemLocationTimelineSkeleton'
import { Button } from '@/components/ui/button'
import { useDateFormatter } from '@/hooks/useDateFormatter'
import { formatBuildingFloorLocation } from '@/utils/location'
import { MapPin } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { ItemLocation } from '../types/item-location'

export function ItemLocationTimeline({
  itemLocations = [],
  isLoading = false,
  onViewMap,
}: {
  itemLocations: ItemLocation[]
  isLoading?: boolean
  onViewMap?: (location: ItemLocation) => void
}) {
  const { t } = useTranslation()
  const { formatDateTime } = useDateFormatter()

  if (isLoading) {
    return <ItemLocationTimelineSkeleton />
  }

  return (
    <>
      {itemLocations?.map((location, i) => {
        const isLast = i === itemLocations.length - 1
        return (
          <div key={location.id} className="flex gap-3">
            <div className="flex w-4 flex-col items-center">
              <div className="mt-2 size-2 flex rounded-full bg-primary"></div>
              {!isLast && <div className="mt-2 w-px flex-1 bg-border/50" />}
            </div>
            <div className={`flex justify-between gap-1 w-full ${isLast ? 'pb-0' : 'pb-4'}`}>
              <div className="flex items-center gap-3">
                <div className="flex flex-col gap-0.5">
                  <span className="text-xs font-medium text-foreground">
                    {location.gatewayName}
                    {' / '}
                    {formatDateTime(location.recordedAt, {
                      day: '2-digit',
                      month: 'short',
                      hour: '2-digit',
                      minute: '2-digit',
                    })}
                  </span>
                  <span className="text-[10px] text-muted-foreground">
                    {[formatBuildingFloorLocation(t, location?.buildingName, location?.floorName)]
                      .filter(Boolean)
                      .join(' / ')}
                  </span>
                </div>
              </div>
              {onViewMap && (
                <div className="flex items-center justify-end">
                  <Button
                    className="size-8 border-primary/30 text-primary hover:bg-primary/10 hover:text-primary"
                    variant="ghost"
                    size="icon"
                    onClick={() => onViewMap(location)}
                  >
                    <MapPin />
                  </Button>
                </div>
              )}
            </div>
          </div>
        )
      })}
    </>
  )
}
